export const array = <T>(value: T | T[]): T[] => {
  return Array.isArray(value) ? value : [value];
};

export const arrayEqual =
  (isEqual: <S>(a: S, b: S) => boolean = (a, b) => a === b) =>
  <T>(a: T, b: T) => {
    if (!Array.isArray(a) || !Array.isArray(b)) {
      return isEqual(a, b);
    }
    if (a.length !== b.length) {
      return false;
    }
    return a.every((item, i) => isEqual(item, b[i]));
  };
